import {isSameMember} from '../../../publica/Page/inscricao/membroFamiliar.js';

/*
 * Regras puras dos documentos (inscricaoAnexos) na etapa Documentos do
 * formulário de inscrição do administrativo: de quem é o documento, a
 * situação dele e a formatação do tamanho.
 */

export const SITUACOES_DOCUMENTO = Object.freeze({
    APROVADO: 'Aprovado',
    NEGADO: 'Negado',
    PARA_ANALISAR: 'Para analisar',
    NAO_SALVO: 'Não salvo'
});

// Padrão das tabelas do sistema para dado ausente.
export const SEM_VALOR = '-';

/* Texto ou "-" quando o campo veio ausente/vazio. */
export const ouTraco = valor => (valor === null || valor === undefined || String(valor).trim() === '' ? SEM_VALOR : String(valor));

/*
 * Situação do documento:
 * - NAO_SALVO: linha nova (sem id) ou com arquivo novo/trocado (anexo.arquivo) ainda não gravado;
 * - APROVADO/NEGADO: pela avaliação vigente (status 'A'/'N');
 * - sem avaliação: PARA_ANALISAR (o `aprovado` antigo ainda vale como aprovado).
 */
export const situacaoDocumento = anexo => {
    if (!anexo || !anexo.id || anexo.anexo?.arquivo) return 'NAO_SALVO';

    const status = String(anexo.avaliacao?.status || '').trim().toUpperCase();
    if (status === 'A') return 'APROVADO';
    if (status === 'N') return 'NEGADO';

    return anexo.aprovado === true ? 'APROVADO' : 'PARA_ANALISAR';
};

/* Situação de uma avaliação do histórico ('A' | 'N'). */
export const situacaoAvaliacao = status => {
    const codigo = String(status || '').trim().toUpperCase();
    if (codigo === 'A') return 'APROVADO';
    if (codigo === 'N') return 'NEGADO';
    return 'PARA_ANALISAR';
};

export const descricaoSituacao = situacao => SITUACOES_DOCUMENTO[situacao] || SEM_VALOR;

/*
 * De quem é o documento: "Inscrito – {nome}" sem integrante (inclui as linhas
 * novas, que o admin anexa para o inscrito); com integrante, "{nome} ({parentesco})",
 * com o nome atual do integrante no formulário e, sem ele, o que veio no anexo.
 */
export const deQuem = (anexo, {nomeInscrito, composicaoFamiliar = []} = {}) => {
    const integrante = anexo?.composicaoFamiliar;
    if (!integrante) {
        const nome = String(nomeInscrito || '').trim();
        return nome ? `Inscrito – ${nome}` : 'Inscrito';
    }

    const atual = (composicaoFamiliar || []).find(membro => isSameMember(membro, integrante)) || null;
    const nome = String(atual?.descricao || integrante.descricao || '').trim() || 'Integrante do grupo familiar';
    const parentesco = atual?.grauParentesco?.descricao || integrante.grauParentesco?.descricao || '';
    return parentesco ? `${nome} (${parentesco})` : nome;
};

const umaCasa = numero => {
    const texto = numero.toFixed(1).replace('.', ',');
    return texto.endsWith(',0') ? texto.slice(0, -2) : texto;
};

/* Tamanho em bytes como "850 B", "12,5 KB", "3 MB"; ausente ou inválido vira "-". */
export const formatarTamanho = bytes => {
    const valor = Number(bytes);
    if (bytes === null || bytes === undefined || bytes === '' || !Number.isFinite(valor) || valor < 0) return SEM_VALOR;
    if (valor < 1024) return `${valor} B`;
    if (valor < 1024 * 1024) return `${umaCasa(valor / 1024)} KB`;
    if (valor < 1024 * 1024 * 1024) return `${umaCasa(valor / (1024 * 1024))} MB`;
    return `${umaCasa(valor / (1024 * 1024 * 1024))} GB`;
};
